(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let header, previous = window.scrollY, accumulated = 0, frame = 0;
  function bindHeader() {
    header = document.querySelector('.section-header');
    if (!header) return;
    header.classList.add('k-floating-header');
    header.classList.toggle('k-compact', window.scrollY > 70);
    header.addEventListener('focusin', () => header.classList.remove('k-header-hidden'));
  }
  function update() {
    frame = 0;
    if (!header) return;
    const y = Math.max(0, window.scrollY), delta = y - previous;
    accumulated = Math.sign(delta) === Math.sign(accumulated) ? accumulated + delta : delta;
    header.classList.toggle('k-compact', y > 70);
    const engaged = header.contains(document.activeElement) || header.querySelector('details[open]') || document.body.className.includes('overflow-hidden');
    if (y < 120 || engaged || accumulated < -8) header.classList.remove('k-header-hidden');
    else if (accumulated > 18) header.classList.add('k-header-hidden');
    previous = y;
  }
  window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
  bindHeader();
  document.addEventListener('shopify:section:load', bindHeader);
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('k-visible'); observer.unobserve(entry.target); }
  }), { threshold: .08 });
  function reveal(root = document) {
    root.querySelectorAll('[data-k-reveal]').forEach(el => {
      if (reduced.matches || window.Shopify?.designMode) return;
      el.classList.add('k-reveal'); observer.observe(el);
    });
  }
  reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  reduced.addEventListener('change', () => document.querySelectorAll('.k-reveal').forEach(el => el.classList.add('k-visible')));
})();
// Each checklist remains independent, including in the theme editor.
document.addEventListener('change', event => {
  if (!event.target.matches('[data-k-check]')) return;
  const card = event.target.closest('.k-match-card');
  const checked = card.querySelectorAll('[data-k-check]:checked').length;
  card.querySelector('[data-k-check-status]').textContent = checked === 3 ? 'All details ready to compare' : `${checked} of 3 details checked`;
});
document.addEventListener('click', event => { if (event.target.closest('[data-k-top]')) window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); });
// Delegated controls also work when sections are reloaded in the theme editor.
document.addEventListener('click', event => {
  const button = event.target.closest('[data-k-lens-choice]');
  if (!button) return;
  const lens = button.closest('[data-k-lens]');
  const index = Number(button.dataset.kLensChoice);
  const content = [
    ['Look beyond the finish.', 'A surface tells only part of the story. Compare the listed material and finish against the requirements of your application.'],
    ['The shape of a better match.', 'Check the dimensions, mounting points, and clearances. Record units consistently when comparing your existing part with a replacement.'],
    ['Where the details come together.', 'Check how the part connects: its mounting, interfaces, and listed compatibility. Similar-looking components may serve different purposes.']
  ][index];
  if (!content) return;
  lens.dataset.view = String(index);
  lens.querySelectorAll('[data-k-lens-choice]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  lens.querySelector('[data-k-lens-title]').textContent = content[0];
  lens.querySelector('[data-k-lens-text]').textContent = content[1];
});
// Prepare an enquiry locally; the customer reviews and submits it on Contact.
document.addEventListener('submit', event => {
  const form = event.target.closest('[data-k-brief]');
  if (!form) return;
  event.preventDefault();
  const part = form.querySelector('[data-k-part]').value.trim();
  if (!part) { form.querySelector('[data-k-part]').focus(); return; }
  const model = form.querySelector('[data-k-model]').value.trim();
  const quantity = form.querySelector('[data-k-qty]').value;
  const body = `Hello, I would like to ask about:\n\nPart / reference: ${part}\nEquipment / model: ${model || 'Not provided'}\nQuantity: ${quantity}\n\nMy question:\n`;
  try { sessionStorage.setItem('khansa-enquiry', JSON.stringify({body, created:Date.now()})); }
  catch { form.querySelector('[data-k-brief-status]').textContent = 'Please include your part details on the contact page.'; window.location.assign(form.action); return; }
  window.location.assign(form.action);
});
(() => {
  const field = document.getElementById('ContactForm-body');
  if (!field) return;
  try {
    const draft = JSON.parse(sessionStorage.getItem('khansa-enquiry') || 'null');
    if (!draft || Date.now() - draft.created > 30 * 60 * 1000 || typeof draft.body !== 'string') return;
    if (!field.value.trim()) { field.value = draft.body; field.dispatchEvent(new Event('input', {bubbles:true})); }
    sessionStorage.removeItem('khansa-enquiry');
  } catch { /* Contact remains usable when storage is unavailable. */ }
})();
// Keep WhatsApp visible while scrolling; show back-to-top below the fold.
(() => {
  const top = document.querySelector('[data-k-top]');
  if (!top) return;
  const update = () => { top.hidden = window.scrollY < 400; };
  update();
  window.addEventListener('scroll', update, {passive:true});
})();
// Arrow keys complement standard Tab/Enter navigation in the detail studio.
document.addEventListener('keydown', event => {
  const button = event.target.closest('[data-k-lens-choice]');
  if (!button || !['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
  event.preventDefault();
  const buttons = [...button.closest('[data-k-lens]').querySelectorAll('[data-k-lens-choice]')];
  let index = buttons.indexOf(button);
  if (event.key === 'Home') index = 0;
  else if (event.key === 'End') index = buttons.length - 1;
  else index = (index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
  buttons[index].focus(); buttons[index].click();
});
(() => {
  function compact(root = document) {
    root.querySelectorAll('[data-k-compact-details]').forEach(item => {
      item.open = !window.matchMedia('(max-width: 749px)').matches;
    });
  }
  compact();
  document.addEventListener('shopify:section:load', event => compact(event.target));
})();
document.addEventListener('input', event => {
 if (!event.target.matches('[data-k-help-query]')) return;
 const root = event.target.closest('[data-k-help]'), query = event.target.value.trim().toLowerCase();
 let count = 0;
 root.querySelectorAll('.k-help__questions details').forEach(item => { const match = item.textContent.toLowerCase().includes(query); item.hidden = !match; if(match) count++; });
 root.querySelector('[data-k-help-status]').textContent = query ? `${count} matching ${count === 1 ? 'question' : 'questions'}` : '';
 root.querySelector('[data-k-help-empty]').hidden = count !== 0;
});

// Prepare a part-specific enquiry without sending a message.
document.addEventListener('click', event => {
 const link = event.target.closest('[data-k-product-enquiry]');
 if (!link) return;
 const root = link.closest('product-info');
 const sku = root.querySelector('[id^="Sku-"]')?.textContent.trim() || '';
 const choices = [...root.querySelectorAll('variant-selects input:checked, variant-selects option:checked')].map(x => x.value).join(' / ');
 const quantity = root.querySelector('input[name="quantity"]')?.value || '1';
 try { sessionStorage.setItem('khansa-enquiry', JSON.stringify({created:Date.now(), body:`Hello, I would like to ask about:\n\nItem: ${link.dataset.productTitle}\nReference: ${sku}\nOption: ${choices}\nQuantity: ${quantity}\n\nMy question:\n`})); } catch { /* The contact link remains usable. */ }
});

// Mirror the real purchase form; one native button remains the source of truth.
(() => {
 const root = document.querySelector('product-info[id^="MainProduct-"]');
 const bar = root?.querySelector('[data-k-mobile-purchase]');
 if (!bar) return;
 const proxy = bar.querySelector('button');
 function sync() {
   const source = root.querySelector('product-form button[name="add"]');
   const price = root.querySelector('[id^="price-"] .price');
   if (!source) { bar.hidden = true; return; }
   const r = source.getBoundingClientRect();
   bar.hidden = !matchMedia('(max-width:749px)').matches || r.bottom >= 0 || !!document.querySelector('#cart-notification.active, cart-drawer.active, quick-add-modal[open]');
   proxy.disabled = source.disabled || source.classList.contains('loading');
   const label = source.querySelector('span');
   proxy.textContent = label?.textContent.trim() || 'Add to cart';
   const value = price?.querySelector('.price__sale .price-item--sale');
   const regular = price?.querySelector('.price__regular .price-item');
   bar.querySelector('[data-k-purchase-price]').textContent = (price?.classList.contains('price--on-sale') ? value : regular)?.textContent.trim() || '';
 }
 proxy.addEventListener('click', () => root.querySelector('product-form button[name="add"]')?.click());
 let pending = false;
 const schedule = () => { if(pending) return; pending = true; requestAnimationFrame(() => {pending = false; sync();}); };
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
 new MutationObserver(schedule).observe(root.querySelector('.product__info-container'),{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class']});
 document.addEventListener('click',schedule);
 const notification = document.getElementById('cart-notification');
 if(notification) new MutationObserver(schedule).observe(notification,{attributes:true,attributeFilter:['class']});
 sync();
})();

